import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { FONTS, SCREEN_PADDING, TYPOGRAPHY } from '@/styles';
import { ItemDetailTabSection } from './item-detail-tab-section';
import { StyleProp, Text, View, ViewProps, ViewStyle } from 'react-native';

interface Props {
  children: React.ReactNode;
  hideTab?: boolean;
  horizontal?: boolean;
  style?: StyleProp<ViewStyle>;
  title: string;
}

export const RichInfoSection: React.FC<Props> = ({
  children,
  hideTab = false,
  horizontal,
  style,
  title,
}) => {
  const [styles] = useStyles();

  const sharedProps: ViewProps = {
    children: horizontal ? (
      <>
        <View style={styles.horizontalLeft}>
          <Text style={[TYPOGRAPHY.large, FONTS.primaryBold]}>{title}</Text>
        </View>
        <View style={styles.horizontalRight}>{children}</View>
      </>
    ) : (
      <>
        <Text style={[TYPOGRAPHY.small, styles.title]}>{title}</Text>
        {children}
      </>
    ),
    style: [horizontal ? styles.sectionHorizontal : styles.section, style],
    testID: 'rich-info-section',
  };

  if (hideTab) {
    return <View {...sharedProps} />;
  }

  return <ItemDetailTabSection title={title} {...sharedProps} />;
};

const useStyles = createStyles((theme) => ({
  horizontalLeft: {
    flex: 2,
  },
  horizontalRight: {
    flex: 10,
  },
  section: {
    marginBottom: SCREEN_PADDING,
  },
  sectionHorizontal: {
    borderTopColor: theme.colors.stroke,
    borderTopWidth: 1,
    flexDirection: 'row',
    marginBottom: 16,
    paddingTop: 16,
  },
  title: {
    ...FONTS.primaryBold,
    lineHeight: 16,
    marginBottom: 8,
    textTransform: 'uppercase',
  },
}));
